import { useContext } from "react"
import { AuthContext } from "../../contexts/AuthContext"
import { ParameterContext } from '../../contexts/ParameterContext';
import { Navigate } from "react-router-dom"

const DirectorApplicationsGuard = ({ children }) => {
    const { user } = useContext(AuthContext);
    const { parameters } = useContext(ParameterContext);

    let directorApplicationsEnabled = 1;

    if (parameters && parameters.nomParameters) {
        const directorApplicationsEnabledParam = parameters.nomParameters.find(x => x.param_name == 'DIRECTOR_APPLICATIONS_ENABLED');
        directorApplicationsEnabled = directorApplicationsEnabledParam ? directorApplicationsEnabledParam.value : 1;
    }

    const isRestrictedDirector = user.role === "Director" && directorApplicationsEnabled == 0;

    if (isRestrictedDirector) {
        return <Navigate to="/schadm/home" replace />;
    }

    return children;
};

export default DirectorApplicationsGuard;